import type { ISubModuleConfig } from '~/features/news/submodule'

export default function createNewsRoutes(config: ISubModuleConfig) {
  return [
    {
      name: config.submodulePermissions.PERMISSION,
      path: config.submodulePermissions.ROUTE,
      component: () => import('~/pages/news/ui/NewsPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.CREATE.PERMISSION,
      path: config.submodulePermissions.CREATE.ROUTE,
      component: () => import('~/pages/news/ui/NewsFormPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    ...(config.submodulePermissions.CREATE.SELECT_PROJECT
      ? [{
          name: config.submodulePermissions.CREATE.SELECT_PROJECT.PERMISSION,
          path: config.submodulePermissions.CREATE.SELECT_PROJECT.ROUTE,
          component: () => import('~/pages/news/ui/NewsSelectionProjectPage.vue'),
          meta: { middleware: ['auth'] },
          props: config,
        }]
      : []
    ),
    {
      name: config.submodulePermissions.EDIT.PERMISSION,
      path: config.submodulePermissions.EDIT.ROUTE,
      component: () => import('~/pages/news/ui/NewsFormPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.DETAIL.PERMISSION,
      path: config.submodulePermissions.DETAIL.ROUTE,
      component: () => import('~/pages/news/ui/NewsDetailPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    ...('SPEECH_REVIEW' in config.submodulePermissions && config.submodulePermissions.SPEECH_REVIEW
      ? [{
          name: config.submodulePermissions.SPEECH_REVIEW.PERMISSION,
          path: config.submodulePermissions.SPEECH_REVIEW.ROUTE,
          component: () => import('~/pages/news/ui/MySpeechReviewPage.vue'),
          meta: { middleware: ['auth'] },
          props: config,
        }]
      : []),
    ...('REORDER' in config.submodulePermissions && config.submodulePermissions.REORDER
      ? [{
          name: config.submodulePermissions.REORDER.PERMISSION,
          path: config.submodulePermissions.REORDER.ROUTE,
          component: () => import('~/pages/news/ui/MySpeechReorderPage.vue'),
          meta: { middleware: ['auth'] },
          props: config,
        }]
      : []),
    {
      name: config.submodulePermissions.COMMENTS.PERMISSION,
      path: config.submodulePermissions.COMMENTS.ROUTE,
      component: () => import('~/pages/comments/ui/CommentsPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
  ]
}
